/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SavingVMHalfFullIcon = /*#__PURE__*/ createSvgIcon(
  'SavingVMHalfFullIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 1A.5.5 0 013 .5h14a.5.5 0 010 1H3a.5.5 0 01-.5-.5zM2.5 19a.5.5 0 01.5-.5h14a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 .5a.5.5 0 01.5.5v3.79c0 1.926.705 3.08 1.552 3.765.867.7 1.93.945 2.668.945h.56c.739 0 1.801-.244 2.668-.945.846-.684 1.552-1.84 1.552-3.765V1a.5.5 0 011 0v3.79c0 2.204-.825 3.654-1.923 4.543-1.078.871-2.376 1.167-3.297 1.167h-.56c-.921 0-2.219-.296-3.297-1.167C5.325 8.444 4.5 6.994 4.5 4.79V1A.5.5 0 015 .5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.052 11.442c-.846.682-1.552 1.837-1.552 3.768V19a.5.5 0 01-1 0v-3.79c0-2.209.824-3.66 1.923-4.547C7.502 9.793 8.8 9.5 9.72 9.5h.56c.92 0 2.218.293 3.297 1.163 1.099.888 1.923 2.338 1.923 4.547V19a.5.5 0 01-1 0v-3.79c0-1.931-.706-3.086-1.552-3.768-.866-.7-1.928-.942-2.668-.942h-.56c-.74 0-1.802.242-2.668.942z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.381 14.802a8.5 8.5 0 00-5.304-1.058l.126.992a7.5 7.5 0 014.703.946 7.07 7.07 0 005.381.506l-.294-.956a6.07 6.07 0 01-4.612-.43z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SavingVMHalfFullIcon;
